// Catálogo compartido de campos de clientes.
// La página ConfiguracionClientes lo lee para generar los toggles automáticamente.
// Los formularios (AgregarCliente / EditarCliente) lo usan para aplicar
// required={!!camposObligatorios[campo.id]} en cada FormItem.
//
// Para agregar un campo configurable:
//   1. Añadir una entrada a CAMPOS_CONFIGURABLES_CLIENTES
//   2. En el FormItem correspondiente del formulario, agregar:
//      required={!!camposObligatorios['nuevoId']}

export const CAMPOS_FIJOS_REQUERIDOS = ['rfc', 'nombre', 'razonSocial', 'tipoClienteId'];

export const CAMPOS_CONFIGURABLES_CLIENTES = [
  // Datos Generales 
  { id: 'clave',           label: 'Clave',            section: 'Datos Generales' },
  { id: 'curp',            label: 'CURP',             section: 'Datos Generales', soloPersonaFisica: true },
  { id: 'apellidoPaterno', label: 'Apellido Paterno', section: 'Datos Generales', soloPersonaFisica: true },
  { id: 'apellidoMaterno', label: 'Apellido Materno', section: 'Datos Generales', soloPersonaFisica: true },
  { id: 'nombreComercial', label: 'Nombre Comercial', section: 'Datos Generales' },

  // Datos Venta
  { id: 'regimenFiscalId', label: 'Régimen Fiscal',   section: 'Datos Venta' },
  { id: 'usoDeCFDIID',     label: 'Uso de CFDI',      section: 'Datos Venta' },
  { id: 'proyectoId',      label: 'Proyecto',         section: 'Datos Venta' },
  { id: 'vendedorId',      label: 'Vendedor',         section: 'Datos Venta' },
  { id: 'bancoId',         label: 'Banco',            section: 'Datos Venta' },
  { id: 'formaDePagoId',   label: 'Forma de Pago',    section: 'Datos Venta' },
  { id: 'monedaId',        label: 'Moneda',           section: 'Datos Venta' },
  { id: 'diasCredito',     label: 'Días de Crédito',  section: 'Datos Venta' },
  { id: 'limiteCredito',   label: 'Límite de Crédito',section: 'Datos Venta' },
  { id: 'limiteDescuento', label: 'Desc Máx. %',      section: 'Datos Venta' },
  { id: 'precioContadoId', label: 'Precio Contado',   section: 'Datos Venta' },
  { id: 'precioCreditoId', label: 'Precio Crédito',   section: 'Datos Venta' },
  { id: 'leyenda',         label: 'Leyenda',          section: 'Datos Venta' },
  { id: 'clienteDePortal', label: 'Cliente de Portal',section: 'Datos Venta' },

  // Contacto General
  { id: 'nombreContactoGeneral', label: 'Nombre de Contacto', section: 'Contacto General' },
  { id: 'celular',           label: 'Celular',            section: 'Contacto General' },
  { id: 'telefono',          label: 'Teléfono',           section: 'Contacto General' },
  { id: 'paginaWeb',         label: 'Página Web',         section: 'Contacto General' },
  { id: 'correo',            label: 'Correo',             section: 'Contacto General' },
  { id: 'observaciones',     label: 'Observaciones',      section: 'Contacto General' },
  { id: 'impresionEspecial', label: 'Impresión Especial', section: 'Contacto General' },
  { id: 'codigoProveedor',   label: 'Código Proveedor',   section: 'Contacto General' },
];

// Secciones únicas en orden de aparición
export const SECCIONES_CAMPOS = [
  ...new Set(CAMPOS_CONFIGURABLES_CLIENTES.map((c) => c.section)),
];

// Objeto con todos los campos en false como valor con default
export const getDefaultCamposObligatorios = () =>
  Object.fromEntries(
    CAMPOS_CONFIGURABLES_CLIENTES.map((c) => [c.id, false])
  );
